module.exports = __webpack_public_path__ + "1caa5fc5e1f967eeb7b1126db14ae6a3.png";